'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import type { CategoriesEntity } from '@eliadmin/core/src/api/general/types/general-layout-types';

import { Carousel } from '@eliadmin/core/src/components/ui/carousel';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { cn } from '@eliadmin/core/src/utils/style-utils';

import { MdOutlineKeyboardArrowRight } from 'react-icons/md';

export function CategoriesCarousel({ categories, className }: { categories: CategoriesEntity[]; className?: string; }) {
  const options = {
    align: 'start' as const,
  };

  return (
    <section className={cn('custom-section', 'pt-16', className)}>
      <div className={cn('custom-container')}>
        <Carousel
          options={options}
          className={{
            wrapper: 'w-full',
            container: 'w-full gap-6',
            main: 'w-full',
            slide: 'w-full max-w-[262px]',
          }}
          slides={categories.map(category => (
            <CategoryCard category={category} key={category.slug} />
          ))}
        />
      </div>
    </section>
  );
}

function CategoryCard({ category }: { category: CategoriesEntity }) {
  const href = ROUTES.CATEGORY({ slug: category.slug, page: 1 });

  return (
    <Link
      prefetch={false}
      href={href}
      className="col-span-1 flex h-full flex-col gap-6 rounded-[16px] bg-[#F9FAFB] p-6 text-left transition-all hover:opacity-70"
    >
      <div className="flex w-full items-start justify-between">
        <Image
          src={category?.icon?.url ?? '/images/placeholder.png'}
          alt={resolveImageAlt(category?.icon, category?.name)}
          width={48}
          height={48}
          className="object-contain"
        />
        <MdOutlineKeyboardArrowRight size={24} className="text-primary" />
      </div>
      <h2 data-ea-visual-tag="h5" className="text-lg font-medium tracking-tighter lg:text-xl">{category.name}</h2>
    </Link>
  );
}
